import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import type { ConnectionStatus } from '@/store/slices/poc/connectionSlice';

const selectConnectionState = (state: RootState) => state.connection;

/**
 * Returns a map of sixId -> ConnectionStatus for all active connections.
 * SIXes not present in the store are implicitly 'disconnected'.
 */
export const selectConnectionStatusBySixId = createSelector(
  selectConnectionState,
  (connectionState): Record<string, ConnectionStatus> =>
    Object.fromEntries(
      connectionState.connections.map((connection) => [connection.sixId, connection.status])
    )
);
